const TextField = ({ item, isGroupNote }) => {
  return (<>
    {item.content?.trim() ?
      <div className="">
        <p className="text" style={{ whiteSpace: "pre-line" }}>
          {/* {item.content} */}
          {item.IsRepeated === 'true' && item.IsGroupEncounter === 'true' && isGroupNote ? item.PatientName + ' - ' + item.content : item.content}
        </p>
      </div> : <></>}
  </>
  )
}

export default TextField